import { render, staticRenderFns } from "./hcd-page.vue?vue&type=template&id=36749cda&scoped=true"
import script from "./hcd-page.vue?vue&type=script&lang=js"
export * from "./hcd-page.vue?vue&type=script&lang=js"
import style0 from "./hcd-page.vue?vue&type=style&index=0&id=36749cda&prod&lang=less&scoped=true"
import style1 from "./hcd-page.vue?vue&type=style&index=1&id=36749cda&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36749cda",
  null
  
)

export default component.exports